module.exports = __webpack_public_path__ + "static/media/Verify_NIN_on_ecitizen.0eb72260.jpg";